/**
 * Small inline icon set. Defined locally so the redesign adds no dependency
 * and every glyph inherits `currentColor` for consistent theming.
 */
type IconProps = { className?: string };

const base = 'h-4 w-4';
const common = {
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function AnalyzeIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M3 16.5V10m4.5 6.5V4m4.5 12.5V8m4.5 8.5v-11" />
    </svg>
  );
}

export function ProfileIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <circle cx="10" cy="7" r="3" />
      <path d="M4 16.5c1.2-2.4 3.4-3.6 6-3.6s4.8 1.2 6 3.6" />
    </svg>
  );
}

export function ResumeIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M6 2.5h5.5L16 6v11.5H6z" />
      <path d="M11 2.5V6h4.5M8.5 10.5h5M8.5 13.5h5" />
    </svg>
  );
}

export function CheckIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M4.5 10.5 8 14l7.5-8" />
    </svg>
  );
}

export function SparkIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 2.5 11.6 8 17 9.5 11.6 11 10 16.5 8.4 11 3 9.5 8.4 8z" />
    </svg>
  );
}

export function ShieldIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 2.5 16 5v5c0 4-2.6 6.7-6 7.5C6.6 16.7 4 14 4 10V5z" />
      <path d="M7.5 10l1.8 1.8 3.2-3.6" />
    </svg>
  );
}

export function ArrowUpIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 15.5v-11M5.5 9 10 4.5 14.5 9" />
    </svg>
  );
}

export function ArrowDownIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 4.5v11M5.5 11 10 15.5 14.5 11" />
    </svg>
  );
}

export function PlusIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 4.5v11M4.5 10h11" />
    </svg>
  );
}

export function TrashIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M4 6h12M8 6V4.5h4V6M6 6l.7 9.2a1.5 1.5 0 0 0 1.5 1.3h3.6a1.5 1.5 0 0 0 1.5-1.3L14 6" />
    </svg>
  );
}

export function EyeOffIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M3 10s2.5-4.5 7-4.5c1 0 1.9.2 2.7.6M17 10s-2.5 4.5-7 4.5c-1 0-1.9-.2-2.7-.6" />
      <path d="M3.5 3.5l13 13" />
    </svg>
  );
}

export function RestoreIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M4 8a6 6 0 1 1 1.6 5.2M4 8V4.5M4 8h3.5" />
    </svg>
  );
}

export function CompareIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 3.5v13M5 6.5 2.5 9 5 11.5M15 8.5 17.5 11 15 13.5" />
    </svg>
  );
}

export function LayersIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 3 3 6.5 10 10l7-3.5z" />
      <path d="M3 10.5 10 14l7-3.5M3 13.5 10 17l7-3.5" />
    </svg>
  );
}

export function RefreshIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M16 7A6.5 6.5 0 0 0 4.6 5.2M4 13a6.5 6.5 0 0 0 11.4 1.8" />
      <path d="M16 3.5V7h-3.5M4 16.5V13h3.5" />
    </svg>
  );
}

export function AlertIcon({ className = base }: IconProps) {
  return (
    <svg {...common} className={className} aria-hidden="true">
      <path d="M10 3.5 17 16H3z" />
      <path d="M10 8.5v3.2M10 14.2h.01" />
    </svg>
  );
}
